<div id="medical_modal" class="modal  custom-modal fade" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_optn_grp_form_title"> {{header}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="medicalForm" (ngSubmit)="onSubmitMedical()" class="horizontal-form" method="post" enctype="multipart/form-data">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Medical Name <span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="medical_id">
                                   <option value="">Select</option>
                                   <option value="{{data.medical_id}}" *ngFor="let data of medicalData">{{data.medical_desc}}</option>
                                </select>
                                <div *ngIf="submitted && mediclErrorMsg.medical_id.errors" class="form-error">
                                    <div *ngIf="mediclErrorMsg.medical_id.errors.required">Medical Name is required !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Lab Name<span class="text-danger">*</span></label>
                                <input class="form-control" type="text" placeholder="Medical Description" formControlName="inst_name">
                                <div *ngIf="submitted && mediclErrorMsg.inst_name.errors" class="form-error">
                                    <div *ngIf="mediclErrorMsg.inst_name.errors.required">Lab Name Description !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Course Start Date<span class="text-danger">*</span></label>
                                <input type="date" class="form-control" formControlName="start_date">
                                <div *ngIf="submitted && mediclErrorMsg.start_date.errors" class="form-error">
                                    <div *ngIf="mediclErrorMsg.start_date.errors.required">Course Start Date !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Validity Date<span class="text-danger">*</span></label>
                                <input type="date" class="form-control" formControlName="valid_date">
                                <div *ngIf="submitted && mediclErrorMsg.valid_date.errors" class="form-error">
                                    <div *ngIf="mediclErrorMsg.valid_date.errors.required">Validity Date !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Attachment<span class="text-danger">*</span></label>
                                <input type="file" class="form-control" (change)="onFileChange($event)" formControlName="attachment">
                                <div *ngIf="submitted && mediclErrorMsg.attachment.errors" class="form-error">
                                    <div *ngIf="mediclErrorMsg.attachment.errors.required">Attachment !</div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
                <div class="modal-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm "><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> SAVE</button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="onReset()" data-dismiss="modal">Close</button>
                </div>
            </form>
        </div>
    </div>
</div>